  import React from 'react';
  import { Form, Input, Button, Card, Space, Breadcrumb, Row , Col } from 'antd';
  import { showSuccess, showError } from '../../../components/errorHandler';
  import { apiRequest } from '../../../service/apiRequest';
  import { useOutletContext } from 'react-router-dom';

import { OutletContextType } from '../../../types/types';

  const ChangePassword: React.FC = () => {
    const [form] = Form.useForm();
    const { darkMode, themeStyles } = useOutletContext<OutletContextType>();

    const breadcrumbItems = [
      { title: 'Dashboard' },
      { title: 'Change Password' },
    ];

    const handleChangePassword = async (values: any) => {
      try {
        const { currentPassword, newPassword, confirmPassword } = values;

        if (newPassword !== confirmPassword) {
          showError('New passwords do not match');
          return;
        }

        const response = await apiRequest({
          method: 'post',
          url: 'update-user-password', // ✅ Your actual API endpoint
          data: {
            current_password: currentPassword,
            new_password: newPassword,
          },
        });

        showSuccess('Password changed successfully!');
        form.resetFields();
      } catch (error) {
        showError('Failed to change password');
      }
    };

    return (
      
        <Space direction="vertical" style={{ width: '100%',  paddingTop: '10' }} size="large">
          <Breadcrumb items={breadcrumbItems} style={{ marginTop: 6 }}/>
          <Row gutter={16} justify="center" style={{ marginTop: 16 }}>
            <Col span={11}>
            <Card title="Change Password">
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleChangePassword}
                >
                  <Form.Item
                    label="Current Password"
                    name="currentPassword"
                    rules={[{ required: true, message: 'Please enter your current password' }]}
                  >
                    <Input.Password placeholder="Enter current password" />
                  </Form.Item>
        
                  <Form.Item
                    label="New Password"
                    name="newPassword"
                    rules={[{ required: true, message: 'Please enter a new password' }]}
                  >
                    <Input.Password placeholder="Enter new password" />
                  </Form.Item>
        
                  <Form.Item
                    label="Confirm New Password"
                    name="confirmPassword"
                    dependencies={['newPassword']}
                    rules={[
                      { required: true, message: 'Please confirm your new password' },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('newPassword') === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(new Error('Passwords do not match'));
                        },
                      }),
                    ]}
                  >
                    <Input.Password placeholder="Confirm new password" />
                  </Form.Item>
        
                  <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                      Change Password
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>
        </Space>
      
    );
    
  };

  export default ChangePassword;
